import React from 'react'
import styled from 'styled-components'
import Servers from './Servers'

const Home = () => {
  return (
    <HomeWrapper>
      <Servers isFeatured={true} />
    </HomeWrapper >
  )
}

const HomeWrapper = styled.section`
  min-height: 100vh;
  padding-bottom: 5rem;
`

export default Home
